// extracted by mini-css-extract-plugin
export default {"link":"collapsible_link__G8GiY","bluePrimary":"collapsible_bluePrimary__WJOtd","content":"collapsible_content__jArNj","breakSpaces":"collapsible_breakSpaces__Qju5c"};